import { render } from "./ProfilePaymentOverview.vue?vue&type=template&id=4472f2f8"
import script from "./ProfilePaymentOverview.vue?vue&type=script&lang=js"
export * from "./ProfilePaymentOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__